import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SetPasswordService {
  http = inject(HttpClient);
  private headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  private apiUrl = environment.apiUrl;
  sendResetEmail(token: string, newpass: string, confrpass: string): Observable<any> {
    return this.http.post(
      `${this.apiUrl}/api/user/reset-password/`,
      { token, new_password: newpass, confirm_password: confrpass },
      { headers: this.headers }
    );
  }
}
